export enum AppMessage {
  AccessToken = 'access-token',
  RideId = 'ride-id',
  Location = 'location',
  Language = 'language',
  UserId = 'user-id',
  ClientProfileUpdated = 'client-profile-updated',
  ChangeLanguageAR = 'change-language-ar',
  ChangeLanguageEN = 'change-language-en',
  Signout = 'signout',
  DeviceModel = 'device-model',
  DeviceOSVersion = 'device-os-version',
  AppVersion = 'app-version',
  UserLogged = 'user-logged'
}
